"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.regexp.split");


































































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Tinymce: _Tinymce.default }, data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, title: '', searchData: { itemId: 5, insId: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', title: '', longContent: '', orderNum: 0, isEnable: true, icon: '' }, rules: { title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }], icon: [{ required: true, message: '请上传文章图标', trigger: 'blur' }], longContent: [{ required: true, message: '请输入文章内容', trigger: 'blur' }], orderNum: [{ required: true, message: '请输入文章排序', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'title', label: '文章标题', isShow: true }, { prop: 'icon', label: '文章图标', isShow: true }, { prop: 'orderNum', label: '排序', isShow: true }, { prop: 'isEnable', label: '是否发布', isShow: true, formatter: function formatter(row, column, cellValue) {return cellValue ? '已发布' : '未发布';} }, { prop: 'deliverTime', label: '发布日期', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/content', self.searchData, function (res) {console.log(res);if (res.length > 0) {self.tableData = res[0].list;self.pageData.page = res[0].pageNum;self.pageData.total = res[0].total;}});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.deliverTimeStart = '';this.searchData.deliverTimeEnd = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;if (this.searchData.deliverTimeEnd) {var endTime = this.searchData.deliverTimeEnd;if (endTime.split(' ').length < 2) {endTime = endTime + ' 23:59:59';this.searchData.deliverTimeEnd = endTime;}}if (this.searchData.deliverTimeStart) {var startTime = this.searchData.deliverTimeStart;if (startTime.split(' ').length < 2) {startTime = startTime + ' 00:00:00';this.searchData.deliverTimeStart = startTime;}}this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, fnUploadRequest: function fnUploadRequest(option) {var path = 'robot/news';_aliOss.default.ossUploadFile(option, path);}, addFun: function addFun() {// 新增
      this.title = '新增';this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, beforeRemove: function beforeRemove(file, fileList) {console.log(file);var fileName = file.name;var confirm = '确定移除' + fileName + '？';return this.$confirm(confirm);}, handleOnRemove: function handleOnRemove(file, fileList) {this.addData.icon = '';this.$message('移除' + file.name + '成功');}, onsuccess: function onsuccess(res) {var imageUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;this.addData.icon = imageUrl;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.newadd = true;
      self.addData = {
        id: item.id,
        icon: item.icon,
        longContent: item.longContent,
        title: item.title,
        orderNum: item.orderNum,
        isEnable: item.isEnable };

      if (this.$refs.tinymce) {
        this.$refs.tinymce.setContent(item.longContent);
      }
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var addData = new Array(0);
          var content = {
            'id': self.addData.id,
            'itemId': 5,
            'title': self.addData.title,
            'longContent': self.addData.longContent,
            'icon': self.addData.icon,
            'orderNum': self.addData.orderNum,
            'isEnable': self.addData.isEnable };

          addData.push(content);
          self.postData('api/temi/content', addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var delContent = { 'id': delId, 'itemId': 5 };
        self.delData('/api/temi/content', delContent, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        title: '',
        longContent: '',
        orderNum: 0,
        icon: '' };

    } } };exports.default = _default;